import {
  SyncingLottieAnimation,
  SuccessLottieAnimation,
} from "web-core/components";
import { useProposalBuilderContext } from "../../providers/proposal-provider";

export function DownloadProposal() {
  const { isDownloading } = useProposalBuilderContext();

  return (
    <div className="flex flex-col flex-1 items-center justify-center">
      {isDownloading ? (
        <>
          <SyncingLottieAnimation height={150} width={150} />
          <span className="text-base font-semibold">
            Generating proposal report
          </span>
          <span className="text-muted-foreground text-sm">
            This may take upto 15 seconds
          </span>
        </>
      ) : (
        <>
          <SuccessLottieAnimation loop={false} height={150} width={150} />
          <span className="text-base font-semibold">
            Proposal report generated
          </span>
        </>
      )}
    </div>
  );
}
